import { AddCircle, Close } from "@mui/icons-material";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Collapse, Box, IconButton } from "@mui/material";
import { FC, useContext, useEffect } from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";

import { VitalsContext, VitalsProvider } from "../TriageContext";
import Edit from "@mui/icons-material/Edit";
import { VitalsDto } from "../../vitals/types";
import { getAllTriage } from "./Services";
import SaveTriage from "./SaveTriage";
import CustomTableBody from "../../../../utilis/component/CustomTableBody";
const TriageList: FC = () => {
    const { encounterId } = useParams();
    const context = useContext(VitalsContext);
    if (!context) {
        throw new Error("VitalsContext must be used within a VitalsProvider");
    }
    const {edit,setEdit,setList,success,setsuccess,show,setShow } = context;
    const { mutate: getTriage, data: vitalsDataList ,isLoading:triageListLoading} = useMutation(getAllTriage,{
      onSuccess: (data) => {
        data?.length>0 && 
        setsuccess(false)
        setList(data) 
      }
    });

    useEffect(() => {
      getTriage(parseInt(encounterId as string));
    }, [success]);


   
  
    return (
      <TableContainer component={Paper}>
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((heading, index) => (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  align="left"
                  key={`heading${index}`}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
              
                  {(!show ) && (
                    <div className="w-full flex justify-end items-center p-2 gap-3">
                      <Button
                        color="success"
                        endIcon={<AddCircle />}
                        onClick={() => {
                          setShow(true);
                          setEdit(null);
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  )}
          
                <Collapse in={show}  timeout="auto" unmountOnExit>
                  <Box>
                    <SaveTriage close={() => setShow(false)} />
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
             </TableBody>
             <CustomTableBody
              isData={Boolean(vitalsDataList?.length)}
              dataLoading={triageListLoading}
              totalSpan={{ row: 5, col: heading.length }} 
              alert="No Triage Found">
                  {vitalsDataList?.map((row: VitalsDto, index:number) => (
              <Fragment key={`vitalsList${index}`}>
                <TableRow key={`vitals${index}`}>
                  <TableCell>{row.height??"--"}</TableCell>
                  <TableCell>{row.weight??"--"}</TableCell>
                  <TableCell>{row.temperature??"--"}</TableCell>
                  <TableCell>
                    {Boolean(edit) && edit?.vitalId === row.vitalId ? (
                      <IconButton
                        color="error"
                        onClick={() => {
                          setEdit(null);
                        }}
                      >
                        <Close />
                      </IconButton>
                    ) : (
                      <IconButton
                        color="primary"
                        onClick={() => {
                          setEdit(row);
                        }}
                      >
                        <Edit />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                    <Collapse
                      in={Boolean(edit) && edit?.vitalId === row.vitalId}
                      timeout="auto"
                      unmountOnExit
                    >
                      <SaveTriage close={() => setEdit(null)} />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
             </CustomTableBody>
        </Table>
      </TableContainer>
    );
  };
  
  const App: FC = () => {
    return (
      <VitalsProvider>
        <TriageList />
      </VitalsProvider>
    );
  };
  
  export default App;
  
  const heading = [ "Height", "Weight", "Temperature", "OPTIONS"];
